import { Grid, useMediaQuery } from "@mui/material"
import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom";
import { AxiosGet, ResultAPI } from "service/CommonFunction/TS_function";
import "./UserVerify.css"
import ImgSugguest00 from "../../../assets/Image/ImgSugguest/0.jpg";

import { i18n } from 'i18n';
const i18nField = 'entities.UserVerify.fields';
const UserVerify = () => {

    const [IsVerified, setIsVerified] = useState(false);
    const [IsError, setIsError] = useState(false);
    const [sError, setError] = useState(null as string);
    const params = useParams();
    const location = useLocation();
    const Layout900 = useMediaQuery('(min-width:900px)');

    useEffect(() => {
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const sID = urlParams.get("sVerify");

        setTimeout(() => {
            if (sID != null) {
                CheckVerify(sID)
            } else {
                setError("Something Wrong!.")
                setIsError(true)
                setIsVerified(false)
            }
        }, 3000);
    }, [])

    const CheckVerify = async (sID) => {
        await AxiosGet(`User/VerifyUser`, { sUserID: sID }, (res) => {
            ResultAPI(res, null, async () => {
                let Result = res.result
                if (Result != null) {
                    setIsVerified(true)
                } else {
                    setError(res.Message)
                    setIsError(true)
                    setIsVerified(false)
                }
            })
        })
    }
    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>

                </div>
                <img src={ImgSugguest00} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover' }} />
            </div>
            {IsVerified ?
                <Grid container justifyContent="center" justifyItems="center" alignContent="center" textAlign="center">
                    <Grid item xs={12}>
                        <h1>{i18n(`${i18nField}.sWelcome`)}</h1>
                    </Grid>
                    <Grid>
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </Grid>
                    <Grid item xs={12}>
                        <p>{i18n(`${i18nField}.sVerified`)}</p>
                    </Grid>
                </Grid>
                : IsError ?
                    <Grid container justifyContent="center" justifyItems="center" alignContent="center" textAlign="center">
                        <Grid item xs={12}>
                            <h1>{i18n(`${i18nField}.sWarning`)}</h1>
                        </Grid>
                        <Grid>
                            {/* <ErrorOutlineRoundedIcon sx={{ fontSize: "70pt", color: "red" }} /> */}
                            <div className="wrapper">
                                <svg className="checkmark_error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                    <circle className="checkmark_circle" cx="26" cy="26" r="25" fill="none" />
                                    <path className="checkmark_check" fill="none" d="M14.1 14.1l23.8 23.8 m0,-23.8 l-23.8,23.8" />
                                </svg>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <p>{sError}</p>
                        </Grid>
                    </Grid>
                    :
                    <Grid container justifyContent="center" justifyItems="center" alignContent="center" textAlign="center">
                        <Grid item xs={12}>
                            <h1>{i18n(`${i18nField}.sWelcome`)}</h1>
                        </Grid>
                        <Grid>
                            <div className="lds-facebook"><div></div><div></div><div></div></div>
                        </Grid>
                        <Grid item xs={12}>
                            <p>{i18n(`${i18nField}.sJustMoment`)}</p>
                        </Grid>
                    </Grid>
            }
        </>
    )
}
export default UserVerify